module.exports = __webpack_public_path__ + "producr-dried fresh-grass-main-thumb-02.jpg?f3b8409663a174943c2b4232ee920f94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-main-thumb-02.jpg
// module id = 57
// module chunks = 0